import BatteryPrice from './BatteryPrice';

export default BatteryPrice;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/ESSPoints/BatteryPrice/index.js